import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import MemberMentorshipPage from "@/pages/member/MemberMentorshipPage";

export const Route = createFileRoute("/member/mentorship/")({
  head: () => pageHead("Member · Mentorship", "AKIVA member · mentorship portal.", "/member/mentorship", true),
  component: MemberMentorshipPage,
});
